import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import './PageFilterModal.scss';

const PageFilterModal = ({ isOpen, onClose, children }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="page-filter-modal"
      size="lg"
      scrollable
      centered
    >
      <ModalHeader toggle={onClose} className="page-filter-modal__header">
        Filter by
      </ModalHeader>
      <ModalBody className="page-filter-modal__body">
        {children}
      </ModalBody>
    </Modal>
  );
};

export default PageFilterModal;
